// @flow
import * as actionTypes from './actionTypes';
import * as contactInfoTypes from './contactInfo/actions';
import * as valetDetailsTypes from './valetDetails/actions';

import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

import contactInfoReducer from './contactInfo/reducer';
import valetDetailsReducer from './valetDetails/reducer';

import { TRANSPORTATION } from 'constants/transportation';

const { DROPOFF, SHUTTLE, WAITER, LOANER, RENTAL, RIDESHARE } = TRANSPORTATION;

export default function(state: any = initialState.appointment, action: any) {
  let vehicle;
  let mileage;
  switch (action.type) {
    case actionTypes.SET_APPOINTMENT:
      return action.payload;
    // APPOINTMENT NODE
    case actionTypes.SET_TEAM_IDS:
      return { ...state, teamIds: action.payload };
    case actionTypes.SET_START_TIME:
      return { ...state, startTime: action.payload };
    case actionTypes.SET_END_TIME:
      return { ...state, endTime: action.payload };
    case actionTypes.CLEAR_START_TIME:
      return { ...state, startTime: null };
    case actionTypes.SET_RESERVATION_ID:
      return { ...state, reservationId: action.payload };
    case actionTypes.SET_APPT_LEAD:
      return { ...state, lead: action.payload };
    case actionTypes.SET_LIFECYCLE_STATE:
      return { ...state, lifecycleState: action.payload };
    case actionTypes.SET_TRANSPORTATION_OPTION:
      return DROPOFF === action.payload ||
        SHUTTLE === action.payload ||
        WAITER === action.payload ||
        LOANER === action.payload ||
        RENTAL === action.payload ||
        RIDESHARE === action.payload
        ? {
            ...state,
            transportationOption: action.payload,
            valetDetails: initialState.appointment.valetDetails
          }
        : { ...state, transportationOption: action.payload };
    case actionTypes.SET_TRANSP_OPTION_INFO:
      return { ...state, transpOptionInfo: action.payload };
    case actionTypes.SET_TRANSPORTATION_LABEL:
      return { ...state, transportationDisplayText: action.payload };
    case actionTypes.SET_ATTENDANCE_STATUS:
      return { ...state, attendanceStatus: action.payload };
    case actionTypes.SET_CONFIRMATION_KEY:
      return { ...state, confirmationKey: action.payload };
    case actionTypes.SET_CALL_BACK:
      return { ...state, callBack: action.payload };
    case actionTypes.SET_CARRY_OVER:
      return { ...state, isCarryOver: action.payload };
    case actionTypes.SET_DMS_APPT:
      return { ...state, isDmsAppt: action.payload };
    case actionTypes.SET_IS_QUOTE_APPT:
      return { ...state, isQuoteAppt: action.payload };
    // PARTICIPANT COMMENTS NODE
    case actionTypes.SET_PARTICIPANT_COMMENTS:
      return { ...state, participantComments: action.payload };
    case contactInfoTypes.SET_CONTACT_INFO:
    case contactInfoTypes.SET_FIRST_NAME:
    case contactInfoTypes.SET_LAST_NAME:
    case contactInfoTypes.SET_EMAIL:
    case contactInfoTypes.SET_PHONE:
    case contactInfoTypes.SET_MOBILE_PHONE:
    case contactInfoTypes.SET_PERSON_ID:
    case contactInfoTypes.SET_EXT_ID:
    case contactInfoTypes.SET_IS_OBFUSCATED:
      return {
        ...state,
        contactInfo: contactInfoReducer(state.contactInfo, action)
      };
    // vehicle node
    case actionTypes.SET_VEHICLE:
      return { ...state, vehicle: action.payload };
    case actionTypes.SET_MAKE:
      vehicle = { ...state.vehicle, make: action.payload, metaVehicleId: null };
      return { ...state, vehicle };
    case actionTypes.SET_YEAR:
      vehicle = { ...state.vehicle, year: action.payload, metaVehicleId: null };
      return { ...state, vehicle };
    case actionTypes.SET_MODEL:
      vehicle = {
        ...state.vehicle,
        model: action.payload,
        metaVehicleId: null
      };
      return { ...state, vehicle };
    case actionTypes.SET_TRANSMISSION:
      vehicle = {
        ...state.vehicle,
        transmission: action.payload,
        metaVehicleId: null
      };
      return { ...state, vehicle };
    case actionTypes.SET_TRIM:
      vehicle = {
        ...state.vehicle,
        trim: action.payload,
        metaVehicleId: null
      };
      return { ...state, vehicle };
    case actionTypes.SET_DRIVE_TYPE:
      vehicle = {
        ...state.vehicle,
        driveType: action.payload,
        metaVehicleId: null
      };
      return { ...state, vehicle };
    case actionTypes.SET_ENGINE_TYPE:
      vehicle = {
        ...state.vehicle,
        engineType: action.payload,
        metaVehicleId: null
      };
      return { ...state, vehicle };
    case actionTypes.SET_ENGINE_SIZE:
      vehicle = {
        ...state.vehicle,
        engineSize: action.payload,
        metaVehicleId: null
      };
      return { ...state, vehicle };
    case actionTypes.SET_REG_DATE:
      vehicle = {
        ...state.vehicle,
        regDate: action.payload
      };
      return { ...state, vehicle };
    case actionTypes.SET_LICENSE_NUMBER:
      vehicle = {
        ...state.vehicle,
        licenseNumber: action.payload
      };
      return { ...state, vehicle };
    case actionTypes.SET_MILEAGE:
      vehicle = {
        ...state.vehicle,
        mileage: action.payload
      };
      return { ...state, vehicle };
    case actionTypes.SET_META_VEHICLE_ID:
      vehicle = { ...state.vehicle, metaVehicleId: action.payload };
      return { ...state, vehicle };
    // customerVehicle
    case actionTypes.SET_CUSTOMER_VEHICLE:
      mileage = action.payload.mileage;
      return {
        ...state,
        vehicle: {
          ...action.payload,
          mileage: mileage ? +mileage : null
        }
      };
    // services
    case actionTypes.SET_SERVICES:
      return {
        ...state,
        services: action.payload
      };
    case actionTypes.ADD_SERVICE:
      return {
        ...state,
        services: [...state.services, action.payload]
      };
    case actionTypes.REMOVE_SERVICE:
      return {
        ...state,
        services: state.services.filter(
          service => service.id !== action.payload
        )
      };
    case actionTypes.UPDATE_APPT_SERVICE_POINT:
    case actionTypes.SET_APPT_SERVICE_POINT:
      return {
        ...state,
        servicePoint: action.payload
      };
    case actionTypes.UPDATE_TELLUSMORE_SERVICE:
      return {
        ...state,
        services: state.services.map(
          service =>
            service.id === action.payload.id
              ? {
                  id: service.id,
                  notes: action.payload.notes,
                  name: action.payload.notes,
                  price: 0
                }
              : service
        )
      };
    case actionTypes.UPDATE_SERVICE_COMMENT:
      return {
        ...state,
        services: state.services.map(
          service =>
            service.id === action.payload.id
              ? {
                  ...service,
                  notes: action.payload.comment
                }
              : service
        )
      };
    case actionTypes.REMOVE_PACKAGE_SERVICE:
      return {
        ...state,
        servicePoint: {
          ...state.servicePoint,
          menuType: {
            ...state.servicePoint.menuType,
            services: state.servicePoint.menuType.services.filter(
              service => service.id !== action.payload
            )
          }
        }
      };
    case actionTypes.ADD_DECLINED_SERVICE:
      return {
        ...state,
        declinedServices: [...state.declinedServices, action.payload]
      };
    case actionTypes.SET_APPT_DECLINED_SERVICES:
      return {
        ...state,
        declinedServices: action.payload
      };
    case actionTypes.REMOVE_DECLINED_SERVICE:
      return {
        ...state,
        declinedServices: state.declinedServices.filter(
          service => service.operationItemId !== action.payload
        )
      };
    case actionTypes.CLEAR_DECLINED_SERVICES:
      return {
        ...state,
        declinedServices: []
      };
    case actionTypes.SET_AUTORECALL_SERVICES:
      return {
        ...state,
        autoRecallServices: action.payload
      };
    case actionTypes.CLEAR_SERVICES:
    case actionTypes.CLEAR_APPT_SERVICES:
      return {
        ...state,
        declinedServices: [],
        services: [],
        servicePoint: null
      };
    case actionTypes.SET_ADVISOR:
      return {
        ...state,
        advisorId: action.payload
      };
    case actionTypes.SET_ADVISOR_NAME:
      return {
        ...state,
        advisorName: action.payload
      };
    case actionTypes.CLEAR_SELECTED_ADVISOR:
      return {
        ...state,
        advisorId: null
      };
    case actionTypes.SET_PRIVACY_SETTINGS:
      return {
        ...state,
        privacySettings: action.payload
      };
    case actionTypes.SET_RESERVATION_STATUS_PRIVACY_SETTINGS:
      return {
        ...state,
        reservationStatusPrivacySettings: action.payload
      };
    // Valet Details
    case valetDetailsTypes.SET_VALET_DETAILS:
    case valetDetailsTypes.SET_DROP_OFF_ADDRESS:
    case valetDetailsTypes.SET_DROP_OFF_ADDRESS_TYPE:
    case valetDetailsTypes.SET_PICK_UP_ADDRESS:
    case valetDetailsTypes.SET_PICK_UP_ADDRESS_TYPE:
    case valetDetailsTypes.SET_VALET_COMMENTS:
    case valetDetailsTypes.SET_PHONE_NO:
    case valetDetailsTypes.SET_PHONE_TYPE:
    case valetDetailsTypes.SET_DROPOFF_PREFERENCE:
      return {
        ...state,
        valetDetails: valetDetailsReducer(state.valetDetails, action)
      };
    case actionTypes.RESET_APPT:
      return { ...initialState.appointment, contactInfo: state.contactInfo };
    case RESET_APP_STATE:
      return initialState.appointment;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/appointment/reducer.js